// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/CriteriosAvaliacoes_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/criterios_avaliacoes/get/{id}
 *
 * get() delegates to Avaliacoes_model::getCriteronByID(), which fetches a
 * single evaluation criterion from the external avaliacoesApi
 * `criteria/get/{id}` endpoint. The criterion carries the same shape as one
 * list item (CriteriosAvaliacoes_ListRow: integer ID + human-readable name),
 * so the Row class is reused here. When the external service has no criterion
 * for the id it returns null Data, so the dados is null.
 */
import type { CriteriosAvaliacoes_ListRow } from './CriteriosAvaliacoes_ListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type CriteriosAvaliacoes_GetResponseDados = CriteriosAvaliacoes_ListRow;

export type CriteriosAvaliacoes_GetResponse = ApiResponse<CriteriosAvaliacoes_GetResponseDados>;

registerResponseContract('CriteriosAvaliacoes_GetResponse', {
  _nullable: { type: 'boolean', required: false },
  ID:        { type: 'number',  required: true },
  name:      { type: 'string',  required: true },
})
